// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linesHeaderStyles } from "@tps/App/Components/Cart/LinesHeader";
import { color, getSystemColor, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: 80px 1fr 1.4fr 1.1fr 1.1fr 1.1fr;
        grid-column-gap: 0;
        grid-auto-flow: column;
        color: ${color("common.white")};
        background: ${color("common.ui5")};
        font-size: 12px;
        line-height: 17px;
        font-weight: 700;
        width: 100%;
        @media print {
            background: ${getSystemColor("common.ui5")};
            color: ${getSystemColor("common.white")};
        }
    `,
};
linesHeaderStyles.itemDescription = {
    css: css`
        grid-column: 1 / 4;
        padding: 5px 12px;
        border-right: 1px solid ${color("common.ui4")};

        ${xScreen("lte", "md")} {
            grid-column: 1 / 6;
            border-right: 0;
        }
    `,
};

linesHeaderStyles.priceUnit = {
    css: css`
        grid-column: 4 / 5;
        padding: 5px 12px;
        border-right: 1px solid ${color("common.ui4")};

        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.qty = {
    css: css`
        grid-column: 5 / 6;
        padding: 5px 12px;
        border-right: 1px solid ${color("common.ui4")};

        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.total = {
    css: css`
        grid-column: 6 / 7;
        padding: 5px 12px;
        padding-right: 13px;
        text-align: right;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
